import type { TRegionDetail } from '@src/config/localisation/locale-config.types'

const makeRegionDetailsData = () => {
  let regionDetails: TRegionDetail | null = null

  const updateRegionDetails = (newRegionDetails: TRegionDetail) => {
    regionDetails = newRegionDetails
  }

  return Object.freeze({
    getRegionDetails: () => regionDetails,
    updateRegionDetails: updateRegionDetails,
  })
}

const regionDetailsHolder = makeRegionDetailsData()

export default regionDetailsHolder
